import * as React from 'react';

import {CheckboxWithAdditionalDetails} from 'shells/checkbox/checkbox-with-additional-details';
import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {UppercaseLabel} from 'shells/typography/uppercase-label';

import {getSubheader, SOCIAL_PROFILE_TYPE, RELATED_COMPANY_TYPE} from './helpers';

import {DataSection} from '.';
import type {AdditionalFields} from '.';

type Props = {
    additionalFields: AdditionalFields;
    isRelatedCompanyChecked: boolean;
    setIsRelatedCompanyChecked: (isRelatedCompanyChecked: boolean) => void;
    isSocialProfilesChecked: boolean;
    setIsSocialProfilesChecked: (isSocialProfilesChecked: boolean) => void;
};

export function ReviewAdditionalFields(props: Props) {
    return (
        <StackLegacy spacing={8}>
            <UppercaseLabel>Other data</UppercaseLabel>
            {props.additionalFields.socialFields &&
                props.additionalFields.socialFields.length > 0 && (
                    <CheckboxWithAdditionalDetails
                        header='Social profiles'
                        subHeader={getSubheader(
                            props.additionalFields.socialFields,
                            SOCIAL_PROFILE_TYPE
                        )}
                        isChecked={props.isSocialProfilesChecked}
                        setIsChecked={props.setIsSocialProfilesChecked}
                    >
                        <DataSection
                            data={props.additionalFields.socialFields}
                            isShowingNew={true}
                            hasBorder={false}
                            topPadding={false}
                        />
                    </CheckboxWithAdditionalDetails>
                )}
            {props.additionalFields.companyFields &&
                props.additionalFields.companyFields.length > 0 && (
                    <CheckboxWithAdditionalDetails
                        header='Related company'
                        subHeader={getSubheader(
                            props.additionalFields.companyFields,
                            RELATED_COMPANY_TYPE
                        )}
                        isChecked={props.isRelatedCompanyChecked}
                        setIsChecked={props.setIsRelatedCompanyChecked}
                    >
                        <DataSection
                            data={props.additionalFields.companyFields}
                            isShowingNew={true}
                            hasBorder={false}
                            topPadding={false}
                        />
                    </CheckboxWithAdditionalDetails>
                )}
        </StackLegacy>
    );
}
